import { Link } from "@tanstack/react-router";

export function Wordmark({
  className = "",
  variant = "default",
}: {
  className?: string;
  variant?: "default" | "inverse" | "badge" | "footer";
}) {
  const isInverse = variant === "inverse";
  const isBadge = variant === "badge";
  const isFooter = variant === "footer";

  return (
    <Link
      to="/"
      className={`flex items-baseline font-bold tracking-tight ${
        isInverse || isFooter ? "text-primary-foreground" : isBadge ? "text-black" : "text-foreground"
      } ${className}`}
    >
      <span className={isInverse || isFooter ? "text-white" : isBadge ? "text-[#004e8c]" : "text-primary dark:text-foreground"}>heall</span>
      <span className={isBadge || isFooter ? "text-black" : ""}>exa</span>
      <span
        className={`ml-1 inline-block h-1.5 w-1.5 translate-y-[-2px] ${
          isInverse || isFooter
            ? "bg-white"
            : isBadge
            ? "bg-[#004e8c]"
            : "bg-primary dark:bg-foreground"
        }`}
        aria-hidden
      />
    </Link>
  );
}
